import styled from 'styled-components';
import { Grid } from '@mui/material';
import { GlobalColors, GlobalFonts } from '../../globals';

export const ContTabsTransformationStartsNow = styled.div`
  width: 100%;
  max-width: 1440px;
  margin: 0 auto;
  padding: 0 20px;

  @media (max-width: 767px) {
    padding: 0 8px;
  }
`;

export const SlideArea = styled.div`
  width: 100%;
  position: relative;
  z-index: 2;
`;

export const SlideViewport = styled.div`
  overflow: hidden;
  width: 100%;
  position: relative;
  z-index: 1;
`;

export const SlideTrack = styled.div`
  display: flex;
  width: 100%;
  transform: translateX(${(props) => `-${props.currentIndex * 100}%`});
  transition: transform 450ms ease;
`;

export const SlideItem = styled.div`
  min-width: 100%;
  width: 100%;
`;

export const SlideContent = styled(Grid)`
  width: 100%;
  margin: 0 !important;
  align-items: center;
`;

export const ContInfoTransform = styled.div`
  width: 80%;
  max-width: 640px;
  padding-right: 24px;

  @media (max-width: 1023px) {
    max-width: 100%;
    width: 100%;
    padding-right: 0;
    text-align: center;
  }
`;

export const TitleTransform = styled.h3`
  margin-bottom: 20px;
  font-family: ${GlobalFonts.fontBold};
  color: ${GlobalColors.colorPrimary};
  font-size: 46px;
  line-height: 56px;

  @media (max-width: 1279px) {
    font-size: 40px;
    line-height: 50px;
  }

  @media (max-width: 1023px) {
    font-size: 34px;
    line-height: 42px;
    text-align: center;
  }

  @media (max-width: 767px) {
    font-size: 28px;
    line-height: 36px;
    margin-bottom: 14px;
    text-align: center;
  }
`;

export const TextTransform = styled.p`
  margin-bottom: 40px;
  font-family: ${GlobalFonts.fontRegular};
  color: ${GlobalColors.colorText};
  font-size: 20px;
  line-height: 28px;

  @media (max-width: 1279px) {
    font-size: 20px;
  }

  @media (max-width: 1023px) {
    text-align: center;
    font-size: 20px;
  }

  @media (max-width: 767px) {
    font-size: 20px;
    line-height: 1.4;
    margin-bottom: 24px;
    max-width: 520px;
    margin-left: auto;
    margin-right: auto;
  }
`;

export const ContPhone = styled.div`
  width: 100%;
  min-height: 560px;
  display: flex;
  align-items: center;
  justify-content: center;

  img {
    display: block;
    width: 100%;
    max-width: 560px;
    max-height: 620px;
    object-fit: contain;
  }

  @media (max-width: 1279px) {
    min-height: 520px;
    img {
      max-width: 500px;
    }
  }

  @media (max-width: 1023px) {
    min-height: auto;
    margin-top: 20px;
    img {
      width: 100%;
      max-width: 440px;
      max-height: none;
    }
  }

  @media (max-width: 767px) {
    margin-top: 8px;
    img {
      max-width: 250px;
    }
  }
`;

export const CarouselControls = styled.div`
  width: 100%;
  margin-top: 8px;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  gap: 40px;
  position: relative;
  z-index: 4;
  padding-bottom: 10px;

  @media (max-width: 1023px) {
    justify-content: center;
    margin-top: 18px;
    padding-bottom: 16px;
  }

  @media (max-width: 767px) {
    margin-top: 20px;
    gap: 12px;
  }
`;

export const ArrowButton = styled.button`
  width: 40px;
  height: 40px;
  border: none;
  background: transparent;
  color: ${GlobalColors.colorText};
  display: inline-flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  flex-shrink: 0;

  &:hover {
    color: ${GlobalColors.colorPrimary};
  }
`;

export const DotsList = styled.div`
  display: flex;
  align-items: center;
  gap: 30px;
  flex-wrap: nowrap;
`;

export const DotButton = styled.button`
  border: none;
  background: transparent;
  cursor: pointer;
  font-family: ${GlobalFonts.fontRegular};
  font-size: 20px;
  line-height: 1;
  color: ${(props) =>
    props.active ? GlobalColors.colorPrimary : GlobalColors.colorGraySuperLight};
  padding: 0 0 10px;
  border-bottom: ${(props) =>
    props.active ? `4px solid ${GlobalColors.colorPrimary}` : '4px solid transparent'};

  @media (max-width: 767px) {
    font-size: 22px;
    padding-bottom: 8px;
  }
`;

export const DesktopCta = styled.div`
  display: block;
  text-align: left;

  #ContButton {
    text-align: left;
    justify-content: flex-start;
    display: flex;
  }

  @media (max-width: 1023px) {
    display: none;
  }
`;

export const MobileCta = styled.div`
  display: none;

  @media (max-width: 1023px) {
    display: flex;
    justify-content: center;
    width: 100%;
    margin-top: 20px;
  }
`;
